export const pageWidth = "75%";
